<template>
    <!--form-->
    <v-form
        class='edit-apartment-form'
        ref='form'
        v-model='valid'
        :disabled='disabledForm'
        lazy-validation
        @submit.prevent='saveApartment(model.apartment)'
    >
        <InitialLoading :init-loading='initLoading' />
        <v-container v-if='!initLoading'>
            <v-row>
                <!--alert-->
                <v-col cols='12'>
                    <h3 class='d-block font-weight-bold flex-grow-1 mb-4 mt-3'>ویرایش اطلاعات مجموعه</h3>
                    <InfoAlert v-if='disabledForm'>
                        <div slot='default'>
                            <span style='white-space: pre-line' class='text--primary'>اطلاعات مجموعه تایید شده و امکان ویرایش آن توسط مدیر میسر نمیباشد. در صورت تمایل به تغییر اطلاعات از طریق درخواست پشتیبانی اقدام کنید</span>
                        </div>
                        <template slot='action'>

                            <v-btn
                                outlined
                                name='CreateSupportRequest'
                                :block='$vuetify.breakpoint.smAndDown'
                                color='primary'
                                class='mb-2 mb-md-0'
                                :to="{
                                    name:'CreateSupportRequest',
                                    query:{
                                        team: 'Support',
                                        apartment_id: apartment_id,
                                        title: `ویرایش اطلاعات مجموعه ${model.apartment.title}`
                                    }
                                }"
                            >
                                <v-icon>mdi-plus</v-icon>
                                <span>ثبت درخواست پشتیبانی</span>
                            </v-btn>

                        </template>
                    </InfoAlert>
                </v-col>
            </v-row>
            <v-row>
                <!--type-->
                <v-col cols='6'>
                    <v-select
                        v-model='model.apartment.type'
                        :items='typeOptions'
                        :rules='rules.apartment.type'
                        return-object
                        required
                        item-text='title'
                        @focus='hideNavigationBar'
                        @blur='showNavigationBar'
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>نوع مجموعه
                        </template>
                    </v-select>
                </v-col>
                <!--practical-->
                <v-col cols='6'>
                    <v-select
                        v-model='model.apartment.practical'
                        :items='practicalOptions'
                        :rules='rules.apartment.practical'
                        return-object
                        required
                        item-text='title'
                        @focus='hideNavigationBar'
                        @blur='showNavigationBar'
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>کاربری
                        </template>
                    </v-select>
                </v-col>
                <!--title-->
                <v-col cols='6'>
                    <v-text-field
                        v-model='model.apartment.title'
                        :rules='rules.apartment.title'
                        placeholder='به طور مثال ساحل '
                        persistent-hint
                        required
                        @focus='hideNavigationBar'
                        @blur='showNavigationBar'
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>عنوان
                        </template>
                    </v-text-field>
                </v-col>
                <!--province-->
                <v-col cols='6'>
                    <v-autocomplete
                        v-model='model.apartment.province'
                        :rules='rules.apartment.province'
                        :items='provinceOptions'
                        item-text='title'
                        no-data-text='یافت نشد'
                        return-object
                        required
                        @focus='hideNavigationBar'
                        @blur='showNavigationBar'
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>استان
                        </template>
                    </v-autocomplete>
                </v-col>
                <!--city-->
                <v-col cols='6'>
                    <v-autocomplete
                        v-model='model.apartment.city'
                        :rules='rules.apartment.city'
                        :items='cityOptions'
                        item-text='title'
                        return-object
                        no-data-text='موردی یافت نشد'
                        required
                        @focus='hideNavigationBar'
                        @blur='showNavigationBar'
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>شهر
                        </template>
                    </v-autocomplete>
                </v-col>
                <!--address-->
                <v-col cols='12' sm='6'>
                    <v-text-field
                        v-model='model.apartment.address'
                        :rules='rules.apartment.address'
                        required
                        @focus='hideNavigationBar'
                        @blur='showNavigationBar'
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>آدرس
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>

            <!--TOWN-->
            <v-row v-if="model.apartment.type.key === 'TOWN'">
                <!--pieceCount-->
                <v-col cols='6'>
                    <v-text-field
                        v-model='model.apartment.pieceCount'
                        :rules='rules.apartment.pieceCount'
                        type='number'
                        required
                        hint='لطفا کیبورد خود را انگلیسی کنید'
                        persistent-hint
                        :disabled='disabled'
                        min='1'
                        @focus='hideNavigationBar'
                        @blur='showNavigationBar'
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>تعداد کل قطعه ها
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <!--APARTMENT-->
            <v-row v-if="model.apartment.type.key !== 'TOWN'">
                <!--number-->
                <v-col cols='6'>
                    <v-text-field
                        v-model='model.apartment.number'
                        :rules='rules.apartment.number'
                        hint='لطفا کیبورد خود را انگلیسی کنید'
                        persistent-hint
                        type='number'
                        required
                        @focus='hideNavigationBar'
                        @blur='showNavigationBar'
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>پلاک
                        </template>
                    </v-text-field>
                </v-col>
                <!--postalCode-->
                <v-col cols='6'>
                    <v-text-field
                        v-model='model.apartment.postalCode'
                        :rules='rules.apartment.postalCode'
                        type='number'
                        label='کد پستی'
                        hint='لطفا کیبورد خود را انگلیسی کنید'
                        persistent-hint
                        @focus='hideNavigationBar'
                        @blur='showNavigationBar'

                    ></v-text-field>
                </v-col>
                <!--alert-->
                <v-col cols='12'>
                    <InfoAlert>
                        <div slot='default'>
                            <span class=''> پس از ثبت تعداد طبقه و تعداد واحد در آینده امکان ویرایش نمیباشد. برای ویرایش باید به پشتیبانی پیام دهید.</span>
                        </div>
                    </InfoAlert>
                </v-col>
                <!--floorCount-->
                <v-col cols='6'>
                    <v-text-field
                        v-model='model.apartment.floorCount'
                        :rules='rules.apartment.floorCount'
                        type='number'
                        hint='لطفا کیبورد خود را انگلیسی کنید'
                        persistent-hint
                        required
                        :disabled='disabled'
                        @focus='hideNavigationBar'
                        @blur='showNavigationBar'
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>تعداد طبقه
                        </template>
                    </v-text-field>
                </v-col>
                <!--unitCount-->
                <v-col cols='6'>
                    <v-text-field
                        v-model='model.apartment.unitCount'
                        :rules='rules.apartment.unitCount'
                        type='number'
                        required
                        hint='لطفا کیبورد خود را انگلیسی کنید'
                        persistent-hint
                        :disabled='disabled'
                        @focus='hideNavigationBar'
                        @blur='showNavigationBar'
                    >
                        <template #label>
                            <span class='red--text'><strong>* </strong></span>تعداد کل واحدها
                        </template>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row class='mb-3'>
                <!--photos-->
                <v-col cols='12' md='6'>
                    <p class='text--secondary subtitle-2 mb-2'>تصاویر مجموعه</p>
                    <div class='image-uploader apartment-images mb-3'>
                        <div class='image-container'
                             v-for='(photo,index) in model.apartment.photos'
                             :key='index'>
                            <v-img
                                class='elevation-3 ma-0'
                                :src='`${public_url}/${photo}`'
                                width='86px'
                                height='86px'
                            >
                                <template v-slot:placeholder>
                                    <v-skeleton-loader type='image' />
                                </template>
                            </v-img>
                            <v-btn
                                icon
                                color='red'
                                class='ma-1 delete-btn'
                                x-small
                                @click='deletePhoto(index)'
                            >
                                <v-icon dark>
                                    mdi-delete
                                </v-icon>
                            </v-btn>
                            <v-btn
                                icon
                                color='primary'
                                class='ma-1 see-btn'
                                x-small
                                @click='viewPhoto(index,"apartment")'
                            >
                                <v-icon dark>
                                    mdi-eye
                                </v-icon>
                            </v-btn>
                            <v-btn
                                dark
                                block
                                color='green'
                                class='mb-1 select-for-cover'
                                x-small
                                @click='selectForCover(index)'
                            >
                                <v-icon small v-if='index === coverIndex'>
                                    mdi-check
                                </v-icon>
                                کاور
                            </v-btn>
                        </div>
                        <form v-if='model.apartment.photos.length < 6'
                              ref='apartment-file-input'>
                            <v-file-input
                                v-if='!loadingUploadImg'
                                ref='fileInput'
                                v-model='photo'
                                accept='image/*'
                                hide-input
                                prepend-icon='mdi-cloud-upload'
                                x-large
                                color='primary'
                                @change='uploadApartmentPhotos'
                            >
                            </v-file-input>
                            <div class='upload-photo-loader' v-if='loadingUploadImg'>
                                <v-progress-circular color='primary' indeterminate width='2' />
                            </div>
                        </form>
                    </div>
                    <InfoAlert>
                        <div slot='default'>
                            <p class='mb-1 d-block'>جهت معرفی بهتر مجموعه بارگذاری تصاویر زیر پیشنهاد میشود</p>
                            <ul class='image-suggestion pr-4'>
                                <li>ورودی مجموعه</li>
                                <li>تصویر هوایی</li>
                                <li>تصویر پلان</li>
                                <li>تصویر از مشاعات</li>
                                <li>تصویر از دفتر مدیریت</li>
                                <li>تصویر مدل شده توسط معمار مجموعه</li>
                            </ul>
                        </div>
                    </InfoAlert>
                </v-col>
                <!--geoLocation-->
                <v-col class='mb-3' cols='12' md='6'>
                    <div class='apartment-location'>
                        <p class='text--secondary subtitle-2 mb-2'>ثبت موقعیت مکانی</p>
                        <LMap
                            class='elevation-5'
                            @click='mapClick'
                            @ready='onReady'
                            @locationfound='onLocationFound'
                            setView
                            :center='[location.latlng.lat,location.latlng.lng]'
                            :zoom='12'
                        >
                            <LTileLayer
                                url='https://{s}.tile.osm.org/{z}/{x}/{y}.png'
                            ></LTileLayer>
                            <LMarker
                                v-if='locationFound'
                                :lat-lng='[model.apartment.geoLocation.lat,model.apartment.geoLocation.lng]'
                            >
                            </LMarker>
                        </LMap>
                    </div>
                </v-col>
            </v-row>

            <v-row>
                <!--global options-->
                <v-col cols='12'>
                    <h3 class='d-block font-weight-bold flex-grow-1 mb-4 mt-3'>امکانات مجموعه</h3>
                    <v-expansion-panels>
                        <v-expansion-panel>
                            <v-expansion-panel-header class='pt-0 pb-0'>مشاهده</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-row no-gutters class='mb-3'>
                                    <!--designBy-->
                                    <v-col cols='12'>
                                        <v-text-field
                                            v-model='model.apartment.designBy'
                                            placeholder='نام یا شرکت طراح مجموعه'
                                            label='طراح'
                                            hide-details
                                            @focus='hideNavigationBar'
                                            @blur='showNavigationBar'
                                        />
                                    </v-col>
                                    <!--buildBy-->
                                    <v-col cols='12'>
                                        <v-text-field
                                            v-model='model.apartment.buildBy'
                                            placeholder='نام یا شرکت سازنده مجموعه'
                                            label='سازنده'
                                            hide-details
                                            @focus='hideNavigationBar'
                                            @blur='showNavigationBar'
                                        />
                                    </v-col>
                                </v-row>
                                <v-row no-gutters class='checkbox-items'>
                                    <v-col cols='6'>
                                        <!--parking-->
                                        <v-checkbox v-model='model.apartment.parking' class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>پارکینگ</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--guard-->
                                        <v-checkbox v-model='model.apartment.guard' class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>نگهبان</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--janitor-->
                                        <v-checkbox v-model='model.apartment.janitor' class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>سرایدار</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--caretakerSuite-->
                                        <v-checkbox v-model='model.apartment.caretakerSuite' class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>سوئیت سرایدار</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--gardener-->
                                        <v-checkbox v-model='model.apartment.gardener' class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>باغبان</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--gym-->
                                        <v-checkbox v-model='model.apartment.gym' class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>باشگاه ورزشی</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--sportField-->
                                        <v-checkbox v-model='model.apartment.sportField'
                                                    class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>زمین ورزشی</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--conference_hall-->
                                        <v-checkbox v-model='model.apartment.conference_hall'
                                                    class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>سالن اجتماعات</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--carwash-->
                                        <v-checkbox v-model='model.apartment.carwash' class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>کارواش</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--supermarket-->
                                        <v-checkbox
                                            v-if='model.apartment.type.key === "TOWN"'
                                            v-model='model.apartment.supermarket'
                                            class='rtl mt-0'
                                        >
                                            <template #label>
                                                <div><strong>فروشگاه</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--emergencyPower-->
                                        <v-checkbox
                                            v-if='model.apartment.type.key!== "TOWN"'
                                            v-model='model.apartment.emergencyPower'
                                            class='rtl mt-0'
                                        >
                                            <template #label>
                                                <div><strong>برق اضطراری</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--fireAlarm-->
                                        <v-checkbox
                                            v-if='model.apartment.type.key!== "TOWN"'
                                            v-model='model.apartment.fireAlarm' class='rtl mt-0'
                                        >
                                            <template #label>
                                                <div><strong>سیستم اعلام و اطفاء حریق</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--masterRoom-->
                                        <v-checkbox
                                            v-if='model.apartment.type.key!== "TOWN"'
                                            v-model='model.apartment.masterRoom'
                                            class='rtl mt-0'
                                        >
                                            <template #label>
                                                <div><strong>اتاق مستر</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--receptionDesk-->
                                        <v-checkbox
                                            v-if='model.apartment.type.key!== "TOWN"'
                                            v-model='model.apartment.receptionDesk'
                                            class='rtl mt-0'
                                        >
                                            <template #label>
                                                <div><strong>میز رسپشن</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--landry-->
                                        <v-checkbox
                                            v-if='model.apartment.type.key!== "TOWN"'
                                            v-model='model.apartment.landry' class='rtl mt-0'>
                                            <template #label
                                            >
                                                <div><strong>لاندری</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--fountain-->
                                        <v-checkbox v-model='model.apartment.fountain' class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>آبنما</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--managerRoom-->
                                        <v-checkbox v-model='model.apartment.managerRoom'
                                                    class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>اتاق مدیریت</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--suite-->
                                        <v-checkbox
                                            v-if='model.apartment.type.key!== "TOWN"'
                                            v-model='model.apartment.suite' class='rtl mt-0'
                                        >
                                            <template #label>
                                                <div><strong>سوئیت</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--furnishKitchen-->
                                        <v-checkbox
                                            v-if='model.apartment.type.key!== "TOWN"'
                                            v-model='model.apartment.furnishKitchen'
                                            class='rtl mt-0'
                                        >
                                            <template #label>
                                                <div><strong>آشپزخانه فرنیش</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--safeBox-->
                                        <v-checkbox
                                            v-if='model.apartment.type.key!== "TOWN"'
                                            v-model='model.apartment.safeBox' class='rtl mt-0'
                                        >
                                            <template #label>
                                                <div><strong>صندوق امانات</strong></div>
                                            </template>
                                        </v-checkbox>
                                    </v-col>

                                    <v-col cols='6'>
                                        <!--tree-->
                                        <v-checkbox v-model='model.apartment.tree' class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>درخت</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--greenSpace-->
                                        <v-checkbox v-model='model.apartment.greenSpace' class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>فضای سبز</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--pool-->
                                        <v-checkbox v-model='model.apartment.pool' class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>استخر</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--babyPool-->
                                        <v-checkbox v-model='model.apartment.babyPool' class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>استخر کودک</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--jacuzzi-->
                                        <v-checkbox v-model='model.apartment.jacuzzi' class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>جکوزی</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--drySauna-->
                                        <v-checkbox v-model='model.apartment.drySauna' class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>سونا خشک</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--steamSauna-->
                                        <v-checkbox v-model='model.apartment.steamSauna'
                                                    class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>سونا بخار</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--roofGarden-->
                                        <v-checkbox v-model='model.apartment.roofGarden'
                                                    class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>روف گاردن</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--flowerBox-->
                                        <v-checkbox v-model='model.apartment.flowerBox' class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>فلاور باکس</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--gazebo-->
                                        <v-checkbox v-model='model.apartment.gazebo' class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>آلاچیق</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--centralEngineRoom-->
                                        <v-checkbox
                                            v-if='model.apartment.type.key!== "TOWN"'
                                            v-model='model.apartment.centralEngineRoom'
                                            class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>موتورخانه مرکزی</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--chiller-->
                                        <v-checkbox
                                            v-if='model.apartment.type.key!== "TOWN"'
                                            v-model='model.apartment.chiller' class='rtl mt-0'
                                        >
                                            <template #label>
                                                <div><strong>چیلر</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--elevator-->
                                        <v-checkbox
                                            v-if='model.apartment.type.key!== "TOWN"'
                                            v-model='model.apartment.elevator' class='rtl mt-0'
                                        >
                                            <template #label>
                                                <div><strong>آسانسور</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--terrace-->
                                        <v-checkbox
                                            v-if='model.apartment.type.key!== "TOWN"'
                                            v-model='model.apartment.terrace' class='rtl mt-0'>
                                            <template #label
                                            >
                                                <div><strong>تراس</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--lobby-->
                                        <v-checkbox
                                            v-if='model.apartment.type.key!== "TOWN"'
                                            v-model='model.apartment.lobby' class='rtl mt-0'>
                                            <template #label
                                            >
                                                <div><strong>لابی</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--coffeeShop-->
                                        <v-checkbox v-model='model.apartment.coffeeShop'
                                                    class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>کافی شاپ</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--audioSystem-->
                                        <v-checkbox
                                            v-if='model.apartment.type.key!== "TOWN"'
                                            v-model='model.apartment.audioSystem'
                                            class='rtl mt-0'>
                                            <template #label>
                                                <div><strong>سیستم صوتی</strong></div>
                                            </template>
                                        </v-checkbox>
                                        <!--internet-->
                                        <v-checkbox
                                            v-if='model.apartment.type.key!== "TOWN"'
                                            v-model='model.apartment.internet' class='rtl mt-0'
                                        >
                                            <template #label>
                                                <div><strong>اینترنت</strong></div>
                                            </template>
                                        </v-checkbox>

                                    </v-col>
                                </v-row>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>

            <!--submit-->
            <v-row>
                <v-col cols='12'>
                    <v-btn
                        :loading='loading'
                        :disabled='disabledForm || !valid'
                        name='submit'
                        color='primary'
                        type='submit'
                        @click='validate'
                    >ثبت
                    </v-btn>
                    <v-btn
                        outlined
                        class='mr-2'
                        @click='goBack'
                    >
                        انصراف
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
        <v-dialog v-model='uploadImageDialog' persistent max-width='420'>
            <v-card outlined>
                <v-row
                    class='fill-height ma-0 text-center'
                    align='center'
                    justify='center'
                >
                    <v-col cols='12'>
                        <p>
                            در حال بارگذاری فایل
                        </p>
                        <v-progress-circular
                            indeterminate
                        ></v-progress-circular>
                    </v-col>
                </v-row>
            </v-card>
        </v-dialog>

    </v-form>
</template>

<script>
    import axios from 'axios';
    import { mapActions, mapState } from 'vuex';
    import { LMap, LMarker, LTileLayer } from 'vue2-leaflet';
    import { Icon } from 'leaflet';
    import InfoAlert from '@/components/Alerts/InfoAlert';
    import InitialLoading from '@/components/initialLoading';
    import { createSupportRequest } from '@/plugins/createSupportRequest';

    delete Icon.Default.prototype._getIconUrl;
    Icon.Default.mergeOptions({
        iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
        iconUrl: require('leaflet/dist/images/marker-icon.png'),
        shadowUrl: require('leaflet/dist/images/marker-shadow.png')
    });
    export default {
        name: 'EditApartmentDetails',
        components: {
            InitialLoading,
            InfoAlert,
            LMap,
            LMarker,
            LTileLayer
        },
        data: () => ({
            supportRequest_id: null,

            locationFound: false,
            location: {
                latlng: {
                    lat: 35.7035767,
                    lng: 51.0128825
                }
            },

            uploadImageDialog: false,
            coverIndex: 0,
            loadingUploadImg: false,
            photo: null,
            initLoading: false,
            loading: false,
            disabled: false,
            apartment_id: null,
            valid: true,
            dialog: false,

            provinceOptions: [],
            typeOptions: [
                { title: 'ساختمان', key: 'APARTMENT' },
                { title: 'شهرک ویلایی', key: 'TOWN' },
                { title: 'برج', key: 'TOWER' }
            ],
            practicalOptions: [
                { title: 'مسکونی', key: 'RESIDENTIAL' },
                { title: 'تجاری', key: 'COMMERCIAL' },
                { title: 'خدماتی', key: 'SERVICES' },
                { title: 'اداری', key: 'OFFICIAL' },
                { title: 'صنعتی', key: 'INDUSTRIAL' },
                { title: 'تفریحی', key: 'ENTERTAINMENT' },
                { title: 'کشاورزی', key: 'AGRICULTURAL' }
            ],

            model: {
                apartment: {
                    geoLocation: {
                        lat: '',
                        lng: ''
                    },
                    id: null,
                    title: null,
                    province: null,
                    city: null,
                    address: null,
                    number: null,
                    postalCode: null,
                    floorCount: null,
                    pieceCount: null,
                    unitCount: null,
                    photos: [],
                    cover: null,
                    type: {
                        key: null
                    }
                }
            },
            rules: {
                apartment: {
                    type: [
                        v => !!v || 'نوع مجموعه اجباری میباشد'
                    ],
                    title: [
                        v => !!v || 'عنوان اجباری میباشد'
                    ],
                    province: [
                        v => !!v || 'استان اجباری میباشد'
                    ],
                    city: [
                        v => !!v || 'شهر اجباری میباشد'
                    ],
                    address: [
                        v => !!v || 'آدرس اجباری میباشد'
                    ],
                    number: [
                        v => !!v || 'پلاک اجباری میباشد (لطفا کیبورد خود را انگلیسی کنید)'
                    ],
                    postalCode: [
                        v => !v ? true : v.match(/\b(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}\b/) ? true : 'کد پستی صحیح نمیباشد'
                    ],
                    floorCount: [
                        v => !!v || 'تعداد طبقه ها اجباری میباشد',
                        v => v % 1 === 0 ? true : 'نمی توان از عدد اعشاری اسفاده کرد'

                    ],
                    unitCount: [
                        v => !!v || 'تعداد کل واحدها اجباری میباشد',
                        v => v < 1 ? 'از اعداد منفی یا عدد ۰ نمی توان استفاده کنید' : true,
                        v => v % 1 === 0 ? true : 'نمی توان از عدد اعشاری اسفاده کرد'
                    ],
                    pieceCount: [
                        v => !!v || 'تعداد کل قطعه ها اجباری میباشد',
                        v => v < 1 ? 'از اعداد منفی یا عدد ۰ نمی توان استفاده کنید' : true,
                        v => v % 1 === 0 ? true : 'نمی توان از عدد اعشاری اسفاده کرد'
                    ]
                }
            },

        }),
        methods: {
            mapClick(e) {
                this.locationFound = false;
                this.model.apartment.geoLocation = { ...e.latlng };
                this.locationFound = true;
            },
            onReady(location) {
                location.locate();
            },
            async onLocationFound(location) {
                this.location = location;
                this.model.apartment.geoLocation = {
                    lat: location.latitude,
                    lng: location.longitude
                };
                this.locationFound = true;
            },

            deletePhoto(index) {
                this.model.apartment.photos.splice(index, 1);
            },
            viewPhoto(index) {
                this.viewPhotoDialog = true;
                this.selectedPhotoForView = this.model.apartment.photos[index];
            },
            selectForCover(index) {
                this.coverIndex = index;
                this.model.apartment.cover = this.model.apartment.photos[index];
            },
            async uploadApartmentPhotos() {
                if (this.photo) {
                    this.loadingUploadApartmentPhotos = true;
                    const photo = this.photo;
                    this.uploadImageDialog = true;
                    const formData = new FormData();
                    formData.append('photo', photo);
                    await axios
                        .post(
                            `api/upload/photos/apartments--${this.model.apartment._id}`,
                            formData
                        )
                        .then((res) => {
                            this.photo = null;
                            this.$refs['apartment-file-input'].reset();
                            if (this.model.apartment.photos.length < 1) {
                                this.coverIndex = 0;
                                this.model.apartment.cover = res.data.url;
                            }
                            this.model.apartment.photos.push(res.data.url);
                        })
                        .catch(err => {
                            this.$snackbar.showMessage({
                                content: 'خطا در بارگذاری تصویر',
                                color: 'error'
                            });
                            this.photo = null;
                            this.$refs['apartment-file-input'].reset();
                            console.error(err);
                        });
                    this.uploadImageDialog = false;
                    this.loadingUploadApartmentPhotos = false;
                }
            },

            hideNavigationBar() {
                this.showNavigation(false);
            },
            showNavigationBar() {
                this.showNavigation(true);
            },

            goBack() {
                this.$store.commit('goBack');
                this.$router.replace(this.$store.state.history.page).catch(() => {
                    this.$router.go(-1);
                });
                this.showNavigationBar();
            },
            validate() {
                this.$refs.form.validate();
                this.showNavigationBar();
            },
            async saveApartment(data) {

                this.loading = true;
                await axios
                    .put(
                        `/api/apartments/${this.apartment_id}`,
                        {
                            ...data,
                            type: data.type.key,
                            practical: data.practical.key
                        }
                    )
                    .then(async (res) => {
                        let apartment = res.data.apartment;
                        let message = 'اطلاعات مجموعه ' + apartment.title + ' اصلاح شد.';
                        await this.$snackbar.showMessage({ content: message, color: 'success' });
                        if(this.model.apartment.supportRequest){
                            await createSupportRequest(apartment.supportRequest, {
                                text: message,
                            })
                        }else{
                            await createSupportRequest(null, {
                                title: `ارتباط با پشتیبانی / مجموعه ${apartment.title}`,
                                apartment: apartment._id,
                                text: message,
                                type: 'APARTMENT_INFO'
                            }).then(async res => {

                                localStorage.setItem('supportRequest_id', res.data.supportRequest._id);
                                apartment.supportRequest = res.data.supportRequest._id;
                                await axios.put(`/api/apartments/${apartment._id}/assign_supportRequest/${apartment.supportRequest}`)
                                    .then(async () => {
                                        let message = 'درخواست پشتیبانی مجموعه' + apartment.title + ' ثبت شد.';
                                        await this.$snackbar.showMessage({content: message, color: 'success'});
                                    }).catch(async err => {
                                        console.error(err);
                                        let message = 'ایجاد درخواست پشتیبانی مجموعه' + apartment.title + ' با خطا مواجه شد.';
                                        await this.$snackbar.showMessage({content: message, color: 'error'});
                                    });

                            });
                        }
                        this.$store.commit('goBack');
                        this.loading = false;
                        this.showNavigationBar();
                        await this.$router.replace(this.$store.state.history.page);
                    })
                    .catch((error) => {
                        console.error(error);
                        this.$error.showError(error.response);
                    });
                this.loading = false;
            },
            async getInitialData(apartment_id) {
                this.loading = true;
                await axios
                    .get(`/api/apartments/${apartment_id}`)
                    .then(response => {
                        this.loading = false;
                        this.supportRequest_id = response.data.apartment.supportRequest;
                        this.disabled = response.data.apartment.status !== 'REGISTERED';
                        this.model.apartment = response.data.apartment;
                        this.model.apartment.type = this.typeOptions.find(item => item.key === response.data.apartment.type) || {
                            title: 'ساختمان',
                            key: 'APARTMENT'
                        };
                        this.model.apartment.practical = this.practicalOptions.find(item => item.key === response.data.apartment.practical);
                        this.model.apartment.geoLocation = {
                            lat: response.data.apartment.geoLocation.lat || '',
                            lng: response.data.apartment.geoLocation.lng || ''
                        };
                        this.locationFound = true;
                    }).catch(err => {
                        this.loading = false;
                        console.error(err);
                    });
            },
            async fetchProvinces() {
                await axios
                    .get('/api/provinces')
                    .then(res => {
                        this.provinceOptions = res.data.provinces;
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            ...mapActions([
                'showBreadCrumbs',
                'setBreadCrumbsTemp',
                'setRole',
                'showNavigation'
            ])
        },
        async created() {
            this.initLoading = true;

            await this.fetchProvinces();
            this.apartment_id = this.$route.params.apartment_id || '';
            if (this.apartment_id) await this.getInitialData(this.apartment_id);

            this.initLoading = false;
            await this.setBreadCrumbsTemp({
                key: 'ApartmentSettings',
                value: {
                    text: `تنظیمات`,
                    href: `/apartments/${this.$route.params.apartment_id}/settings`
                }
            });
            await this.setBreadCrumbsTemp({
                key: 'editApartment',
                value: {
                    text: `ویرایش اطلاعات مجموعه`,
                    href: `/apartments/${this.$route.params.apartment_id}/edit`
                }
            });
        },
        async updated() {
            await this.showBreadCrumbs(['home', 'apartmentDetail', 'ApartmentSettings', 'editApartment']);
        },
        computed: {
            cityOptions() {
                if (this.provinceOptions.length > 0 && this.model.apartment.province) {
                    return this.provinceOptions.find(item => {
                        if (item._id === this.model.apartment.province._id) return item;
                    }).cities;
                }
                return [];

            },
            disabledForm() {
                return this.model.apartment.status === 'APPROVED';
            },
            ...mapState(['user', 'public_url'])
        }
    };
</script>

<style scoped lang='scss'>
    .edit-apartment-form {
        :deep() {

            .image-uploader {
                grid-template-columns: repeat(3, 1fr);
                @media screen and (min-width: 960px) {
                    grid-template-columns: repeat(5, 1fr);
                }
                display: grid;
                grid-gap: 16px;
                justify-items: center;
                align-items: center;

                .image-container {
                    position: relative;

                    .delete-btn {
                        position: absolute;
                        top: 0;
                        left: 0;
                    }

                    .see-btn {
                        position: absolute;
                        top: 0;
                        right: 0;
                    }

                    .select-for-cover {
                        position: absolute;
                        bottom: 0;
                    }
                }

                .upload-photo-loader {
                    width: 86px;
                    height: 86px;
                    display: flex;
                    justify-items: center;
                    align-items: center;

                    > div {
                        margin: auto;
                    }
                }

                .v-image {
                    border-radius: 2.5px;

                    .v-responsive__sizer {
                        padding: 0 !important;
                    }
                }

                .v-text-field {
                    margin: 0;
                    padding-top: 0;

                    .v-input__prepend-outer {
                        margin: 0;

                        .v-input__icon {
                            width: 86px;
                            height: 86px;

                            .v-icon {
                                border: 1px dashed;
                                border-radius: 2.5px;
                                padding: 19.5px;
                                font-size: 45px;

                                &::after {
                                    transform: none;
                                    border-radius: 2.5px;
                                }
                            }

                        }
                    }
                }
            }

            .image-suggestion {
                @media screen and (min-width: 600px) {
                    column-count: 2;
                }
            }

            .apartment-location {
                height: 200px;
                width: 100%;

                .vue2leaflet-map {
                    z-index: 1;
                    border-radius: 4px;
                }
            }

            .checkbox-items {
                .v-label {
                    font-size: 12px;
                }
            }
        }
    }
</style>